import { rolesService } from "@/_services";

export const roles = {
  namespaced: true,
  state: {
    menus: {
      data: {},
      status: {},
    },
    rolesCliente: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getMenusRequest(state) {
      state.menus.status = {
        loading: true,
      };
    },
    getMenusError(state, error) {
      state.menus.data = {};
      state.menus.status = {
        error,
      };
    },
    getMenusSuccess(state, data) {
      state.menus.data = data;
      state.menus.status = {
        loaded: true,
      };
    },
    getRolesClienteRequest(state) {
      state.rolesCliente.status = {
        loading: true,
      };
    },
    getRolesClienteError(state, error) {
      state.rolesCliente.data = {};
      state.rolesCliente.status = {
        error,
      };
    },
    getRolesClienteSuccess(state, data) {
      state.rolesCliente.data = data;
      state.rolesCliente.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getMenus({ commit }) {
      commit("getMenusRequest");
      rolesService
        .getMenus()
        .then((res) => {
          commit("getMenusSuccess", res);
        })
        .catch((error) => {
          commit("getMenusError", error);
        });
    },
    getRolesCliente({ commit }) {
      commit("getRolesClienteRequest");
      rolesService
        .getRolesCliente()
        .then((res) => {
          commit("getRolesClienteSuccess", res);
        })
        .catch((error) => {
          commit("getRolesClienteError", error);
        });
    },
  },
};
